<script>
    import {getObj} from '../lib/data.js';
    import Liquid from 'liquidjs';

    const engine = new Liquid.Liquid();

    export let section;
    let table;

    let table_id;

    async function loadTable(section) {

        if (section.table != table_id){
            table = await getObj("table", section.table);
            table_id = section.table;
        }
    }

    $: loadTable(section);

    function getMerge(row, col) {
        for (let merge of table.data.merge) {
            if (merge.start[0] <= row && merge.end[0] >= row && merge.start[1] <= col && merge.end[1] >= col) {
                return merge
            }
        }
    }


    function generateTable(finding) {
        let generated_table = [];
        for (let row = 0; row < table.data.rows; row++) {
            let generated_row = [];
            for (let col = 0; col < table.data.cols; col++){
                let generated_column = {
                    row: row,
                    col: col,
                    style: "",
                    spans: {}
                }

                // get merged cells
                let merge = getMerge(row, col);
                if (merge != undefined) {
                    if (row == merge.start[0] && col == merge.start[1]) {
                        generated_column.spans.rowspan = merge.end[0] - merge.start[0] + 1;
                        generated_column.spans.colspan = merge.end[1] - merge.start[1] + 1;
                    } else {
                        continue
                    }
                }

                // get row styles
                let row_style = table.data.row_styles[row];
                if (row_style != undefined) {
                    for (let style in row_style) {
                        generated_column.style += `${style}: ${row_style[style]};`;
                    }
                }

                // get column styles
                let col_style = table.data.col_styles[col];
                if (col_style != undefined) {
                    for (let style in col_style) {
                        generated_column.style += `${style}: ${col_style[style]};`;
                    }
                }

                // get cell contents
                let template = table.data.values[[row,col]];
                if (!template) {
                    generate_column.content = "";
                } else {
                    generated_column.content =  engine.parseAndRenderSync(template, finding.details);
                }

                let cell_style = table.data.cell_styles[[row, col]] || {};

                // process conditional formatting
                let conditional_formatting = table.data.conditional_formatting[[row,col]] || [];
                for (let rule of conditional_formatting) {
                    // get raw text without formatting
                    let elem = document.createElement("div");
                    elem.innerHTML = generated_column.content;
                    let condition_check = engine.parseAndRenderSync(`{% if ${rule.condition} %}True{%endif%}`, {value: elem.innerText.trim()});

                    if (condition_check == "True") {
                        if (rule.bold) cell_style['font-weight'] = "bold";
                        if (rule.italic) cell_style['font-style'] = "italic";
                        if (rule.underline) cell_style['text-decoration'] = "underline";
                        cell_style['background-color'] = rule.background;
                        cell_style['color'] = rule.font;
                    }
                }

                // get cell styles
                if (cell_style != undefined) {
                    for (let style in cell_style) {
                        generated_column.style += `${style}: ${cell_style[style]};`;
                    }
                }

                generated_row.push(generated_column);
            }
            generated_table.push(generated_row)
        }

        return generated_table;
    }
</script>

{#if table}
    {#each section.findings as finding}
        <table class="table is-fullwidth">
            <tbody>
            {#each generateTable(finding) as row}
                <tr>
                    {#each row as col}
                            <td
                                data-row = {col.row}
                                data-col = {col.col}
                                {...col.spans}
                                style={col.style}
                            >
                                {@html col.content}
                            </td>
                    {/each}
                </tr>
            {/each}
            </tbody>
        </table>
    {/each}
{/if}